"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../../common/hooks/use-translation-wrapper");
const OcmTNADisclaimer = () => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(react_core_1.Alert, { variant: react_core_1.AlertVariant.info, title: t('ai:Requirements for Two Node control plane OpenShift'), isInline: true },
        react_1.default.createElement(react_core_1.List, null,
            react_1.default.createElement(react_core_1.ListItem, null, t('ai:Two nodes control plane OpenShift must include an additional arbiter node.')))));
};
exports.default = OcmTNADisclaimer;
//# sourceMappingURL=OcmTNADisclaimer.js.map